import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './Users.css'
import { userHasPerm, isSuperAdmin } from '../utils/auth'
import { fetchUsers, updateUser, createUser, deleteUser } from '../redux/users'
import { fetchPerms } from '../redux/perms'
import { fetchLibraries } from '../redux/libraries'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import EditUser from '../components/modals/EditUser'

class Users extends Component {
  state = {
    creating: null,
    editing: null
  }
  componentDidMount () {
    const { users, fetchUsers, perms, fetchPerms, shouldFetchLibraries, fetchLibraries } = this.props
    if (!users) fetchUsers()
    if (!perms) fetchPerms()
    if (shouldFetchLibraries) fetchLibraries()
  }
  toggleDisabled = user => {
    const { updateUser } = this.props
    updateUser(user.id, {
      ...user,
      disabled: !user.disabled
    })
  }
  onCreateUser = data => {
    const { createUser } = this.props
    return createUser(data).then(response => {
      if (response) {
        this.setState({ creating: null })
      }
    })
  }
  onUpdateUser = data => {
    const { updateUser } = this.props
    const { editing } = this.state
    return updateUser(editing.id, data).then(success => {
      if (success) {
        this.setState({ editing: null })
      }
    })
  }
  filterUser = user => {
    if (this.props.superAdmin) {
      return true
    }
    return user.id === this.props.me.id || !userHasPerm(user, 'admin')
  }
  renderRow = (user) => {
    const { deleteUser } = this.props
    const { id, name, email, perms } = user
    return (
      <li key={id} className={user.disabled ? classNames.userDisabled : classNames.user}>
        <div className={classNames.name} title={`ID: ${id}`}>
          {name}
        </div>
        <div className={classNames.email}>
          {email}
        </div>
        <PermList perms={perms} superAdmin={isSuperAdmin(user)} />
        <button
          className={classNames.button}
          onClick={() => this.setState({ editing: user })}>
          Edit
        </button>
        {!isSuperAdmin(user) &&
          <button
            className={classNames.button}
            onClick={() => this.toggleDisabled(user)}>
            {user.disabled ? 'Enable' : 'Disable'}
          </button>
        }
        {!isSuperAdmin(user) &&
          <button
            className={classNames.button}
            onClick={() => {
              if (window.confirm(`Are you sure you want to delete ${user.name}?`)) {
                deleteUser(user.id)
              }
            }}>
            Delete
          </button>
        }
      </li>
    )
  }
  render () {
    const {
      users, fetching, error, perms, libraries, superAdmin,
      fetchUsers
    } = this.props

    const { creating, editing } = this.state

    if (error) {
      return (
        <ErrorMessage
          message='There was an error fetching users'
          onRetry={fetchUsers}
        />
      )
    }

    if (!users || !perms || fetching) {
      return <LoadingSpinner />
    }

    return (
      <div className={classNames.page}>
        <button
          className={classNames.createButton}
          onClick={() => this.setState({ creating: true })}>
          Create new user
        </button>
        <ul>
          {users.filter(this.filterUser).map(this.renderRow)}
        </ul>
        {superAdmin &&
          <div className={classNames.heading}>
            Superadmin permissions
          </div>
        }
        {superAdmin &&
          <ul className={classNames.notes}>
            <li>Manage libraries</li>
            <li>Manage keyword visibility</li>
            <li>Manage keyword weightings</li>
            <li>Merge keyword nodes and remove old notes</li>
            <li>Edit global user settings</li>
            <li>Edit all user permissions and libraries</li>
            <li>View raw album hierarchy</li>
          </ul>
        }
        {creating &&
          <EditUser
            title='New User'
            showPasswordField
            requirePassword
            onSubmit={this.onCreateUser}
            onCancel={() => this.setState({ creating: null })}
            perms={perms}
            libraries={libraries}
            createError={this.props.createError}
            autoFocus
          />
        }
        {editing &&
          <EditUser
            title='Edit User'
            showPasswordField={superAdmin}
            hideAdminPerm={isSuperAdmin(editing)}
            onSubmit={this.onUpdateUser}
            onCancel={() => this.setState({ editing: null })}
            initialValues={{
              ...editing,
              location: getLocationObject(editing)
            }}
            perms={perms}
            libraries={libraries}
          />
        }
      </div>
    )
  }
}

function getLocationObject (user) {
  const [lat, lon] = user.location.split(',').map(value => parseFloat(value))
  return {
    lat,
    lon,
    address: user.location_address
  }
}

function PermList ({ perms, superAdmin }) {
  return (
    <ul className={classNames.permList}>
      {superAdmin &&
        <li className={classNames.permSuperAdmin}>
          superadmin
        </li>
      }
      {perms.map(({ perm }) => (
        <li key={perm.id} className={classNames.perm}>
          {perm.perm_token}
        </li>
      ))}
    </ul>
  )
}

const mapStateToProps = ({ users, entities, perms, libraries, auth }) => ({
  me: auth.user,
  users: users.data && users.data.map(id => entities.users[id]),
  fetching: users.fetching,
  error: users.error,
  perms: perms.data,
  libraries: isSuperAdmin(auth.user) ? libraries.data && libraries.data.map(library => ({ library })) : auth.user.libraries,
  superAdmin: isSuperAdmin(auth.user),
  createError: users.create.error,
  shouldFetchLibraries: isSuperAdmin(auth.user) && !libraries.data
})

const mapDispatchToProps = {
  fetchUsers,
  updateUser,
  createUser,
  deleteUser,
  fetchPerms,
  fetchLibraries
}

export default connect(mapStateToProps, mapDispatchToProps)(Users)



// WEBPACK FOOTER //
// ./src/pages/Users.js